module.exports = __webpack_public_path__ + "assets/images/probe_2_wire.png";